import { render, staticRenderFns } from "./navigateSettings.vue?vue&type=template&id=00fab163&scoped=true&"
import script from "./navigateSettings.vue?vue&type=script&lang=js&"
export * from "./navigateSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fab163",
  null
  
)

export default component.exports